import { createApp } from 'vue';
import LocationsList from './Locations.vue';

// mount selector
const moduleSelector = '.locations-app';

/**
 * Vue.js Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules) return;

  modules.forEach((query) => {
    try {
      // vue components init
      createApp(LocationsList).mount(query);
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
